import { useState, useRef, useCallback } from 'react'

export const useApi = () => {
  const [state, setState] = useState({
    data: null,
    loading: false,
    error: null
  })
  
  const abortControllerRef = useRef(null)

  const execute = useCallback(async (apiCall) => {
    // Cancel any ongoing request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
    }

    // Create new abort controller
    abortControllerRef.current = new AbortController()

    // Don't start if already loading
    if (state.loading) return

    try {
      setState(prev => ({ ...prev, loading: true, error: null }))
      const result = await apiCall()
      setState(prev => ({ ...prev, data: result, loading: false }))
      return result
    } catch (err) {
      if (err.name === 'AbortError') return
      setState(prev => ({ ...prev, error: err, loading: false }))
      throw err
    }
  }, [state.loading])

  return {
    ...state,
    execute
  }
}

export default useApi 